/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import { string } from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { useBreakpoint, Typography } from '@one-thd/sui-atomic-components';
import { useProductInfoStore } from '../../store';

const DraftBannerDesktop = ({ productInfo }) => (
  <>
    <Typography variant="h2" weight="display" height="loose">{productInfo?.productName} - Draft </Typography>
    <Typography variant="body-lg">
      Last Updated: {new Date(productInfo?.draftProductLastUpdated).toString()}
    </Typography>
  </>
);

const DraftBannerMobile = ({ productInfo }) => (
  <>
    <Typography variant="h4" weight="display" height="loose">{productInfo?.productName} - Draft </Typography>
    <Typography variant="body-xs">
      Last Updated: {new Date(productInfo?.draftProductLastUpdated).toString()}
    </Typography>
  </>
);

const DraftBanner = ({ draftProductId }) => {
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const matches = useBreakpoint('lg');
  const isDesktop = matches.greater;

  if (!draftProductId || _isEmpty(productInfo)) {
    return null;
  }

  return (
    <div className="sui-absolute sui-z-max sui-top-0 sui-left-0 sui-right-0 sui-bg-warning sui-p-4 md:sui-h-36 lg:sui-h-32">
      {isDesktop && (<DraftBannerDesktop productInfo={productInfo} />)}
      {!isDesktop && (<DraftBannerMobile productInfo={productInfo} />)}
    </div>
  );
};

DraftBanner.propTypes = {
  draftProductId: string
};

DraftBanner.defaultProps = {
  draftProductId: null
};

export default DraftBanner;
